module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_4.799040d8.mp3";